/**
 * Parses a date string or Date object correctly.
 * If the input is a string without timezone offset information,
 * it assumes it is in Tajikistan timezone (UTC+5) and parses it accordingly.
 * 
 * @param {string|Date|number} dateInput 
 * @returns {Date}
 */
export const parseDateInTajikistan = (dateInput) => {
  if (!dateInput) return new Date();
  if (dateInput instanceof Date) return dateInput;
  if (typeof dateInput === 'number') return new Date(dateInput);

  let str = String(dateInput).trim();
  // Check if it already contains timezone info (Z, +HH:MM, +HH, -HH:MM, -HH)
  const hasTimezone = /Z$/i.test(str) || /[+-]\d{2}(:?\d{2})?$/.test(str);

  if (!hasTimezone) {
    // Normalize spaces to T
    if (str.includes(' ') && !str.includes('T')) {
      str = str.replace(' ', 'T');
    }
    // Append Tajikistan timezone offset
    str = str + '+05:00';
  }

  const parsed = new Date(str);
  return isNaN(parsed.getTime()) ? new Date(dateInput) : parsed;
};

/**
 * Formats a Date object as a time string (HH:mm:ss) in Tajikistan timezone.
 * 
 * @param {Date} date 
 * @param {boolean} includeSeconds 
 * @returns {string}
 */
export const formatTajikistanTime = (date, includeSeconds = true) => {
  return new Intl.DateTimeFormat("ru-RU", {
    timeZone: "Asia/Dushanbe",
    hour: "2-digit",
    minute: "2-digit",
    second: includeSeconds ? "2-digit" : undefined,
    hour12: false
  }).format(date);
};

/**
 * Formats a Date object as a date string in Tajikistan timezone.
 * 
 * @param {Date} date 
 * @returns {string}
 */
export const formatTajikistanDate = (date) => {
  return new Intl.DateTimeFormat("ru-RU", {
    timeZone: "Asia/Dushanbe",
    day: "numeric",
    month: "long",
    year: "numeric"
  }).format(date).replace(/\s*г\.$/, '').replace(' г.', '');
};
